// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAlarmSubscription_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.69617L2.50261 19.9999H6.99998V21.9999H1.30499C0.296385 21.9999 -0.329798 20.8889 0.182838 20.0088L10.8778 1.64915C11.382 0.783612 12.6179 0.783613 13.1221 1.64915L17.9867 9.99997H15.6721L12 3.69617ZM11.908 14L16.5 16.8258L21.0919 14H11.908ZM11 15.7895V21.9999H21.9999V15.7895L16.5 19.1741L11 15.7895ZM8.99998 12H23.9999V23.9999H8.99998V12ZM21.5 6.87656C21.5 7.44481 21.4052 7.99092 21.2306 8.49994L19.3797 7.72061C19.458 7.45287 19.5 7.16962 19.5 6.87656C19.5 5.24602 18.1992 3.91931 16.5788 3.87758L17.0457 1.906C19.5504 2.17785 21.5 4.29953 21.5 6.87656Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAlarmSubscription is a generated icon component.
 */
let IconMedAlarmSubscription = IconMedAlarmSubscription_1 = class IconMedAlarmSubscription extends IconBaseElement {
    render() {
        return html `${IconMedAlarmSubscription_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAlarmSubscription.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedAlarmSubscription = IconMedAlarmSubscription_1 = __decorate([
    customElement('zui-icon-med-alarm-subscription')
], IconMedAlarmSubscription);
export { IconMedAlarmSubscription };
